var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "118px",
    height: "120px",
    viewBox: "0 0 118 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 28") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0224344262 117.976107 0.0224344262 117.976107 118.024298 0 118.024298"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 118.977566 117.976595 118.977566 117.976595 0.975409836 0 0.975409836"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avenu---Visual-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0-Homepage-default",
    transform: "translate(-179.000000, -4720.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(179.000000, 4720.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.952975)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.976107,59.022732 C117.976107,26.438191 91.5665372,0.0221418033 58.9878099,0.0221418033 C26.4090826,0.0221418033 -0.000487603306,26.438191 -0.000487603306,59.022732 C-0.000487603306,91.6082484 26.4090826,118.024298 58.9878099,118.024298 C91.5665372,118.024298 117.976107,91.6082484 117.976107,59.022732",
    id: "Fill-1",
    fill: "#27BFC5",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.4081223,57.6419418 C38.4081223,66.5903516 33.4989322,66.8215238 33.8490314,72.7461631 C34.2371636,79.3087205 39.3657752,79.3233516 39.3657752,83.8346221 C39.3657752,88.3449172 34.649676,93.4004664 38.8274612,98.2580074 L58.9888826,98.2580074 L58.9888826,43.538491 L38.4081223,57.6419418 Z",
    id: "Fill-4",
    fill: "#2E576D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5516017,57.3457098 C79.5516017,66.2941197 84.4617669,66.5252918 84.1106926,72.4499311 C83.7225603,79.0124885 78.594924,79.0271197 78.594924,83.5383902 C78.594924,88.0486852 83.3090727,93.1052098 79.1322628,97.9617754 L58.9708413,97.9617754 L58.9708413,43.2432344 L79.5516017,57.3457098 Z",
    id: "Fill-6",
    fill: "#2E576D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4329702,48.2945893 C81.4329702,35.8112943 71.3805405,25.6904418 58.9807884,25.6904418 C46.5800612,25.6904418 36.5276314,35.8112943 36.5276314,48.2945893 C36.5276314,60.7778844 46.5800612,70.8987369 58.9807884,70.8987369 C71.3805405,70.8987369 81.4329702,60.7778844 81.4329702,48.2945893",
    id: "Fill-8",
    fill: "#2E576D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2447603,89.3828508 C81.7096364,82.6895885 58.9804959,78.4884984 58.9804959,78.4884984 C58.9804959,78.4884984 36.2503802,82.6895885 32.7152562,89.3828508 C30.1026777,98.6707033 30.6361157,98.2581049 30.6361157,98.2581049 L58.9804959,98.2581049 L88.230843,98.2581049 C88.230843,98.2581049 88.5672893,97.8181951 85.2447603,89.3828508",
    id: "Fill-10",
    fill: "#F1C9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0737488,98.2577148 L87.3240959,98.2577148 C87.3240959,98.2577148 87.6605421,97.8187803 84.3380132,89.3824607",
    id: "Fill-12",
    fill: "#F1C9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9803983,78.4884984 C58.9803983,78.4884984 81.7095388,82.6895885 85.2446628,89.3828508 C88.5671917,97.8181951 88.2307455,98.2581049 88.2307455,98.2581049 L58.9803983,98.2581049 L58.9803983,78.4884984 Z",
    id: "Fill-14",
    fill: "#E4B692"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#F1C9A5",
    mask: "url(#mask-4)",
    points: "52.7928099 85.5941639 65.1681818 85.5941639 65.1681818 64.8793852 52.7928099 64.8793852"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#E4B692",
    mask: "url(#mask-4)",
    points: "58.9804959 85.5941639 65.1681818 85.5941639 65.1681818 64.8793852 58.9804959 64.8793852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7924198,74.4792713 C53.9051306,77.6737385 58.3969322,79.5055582 61.695081,79.5055582 C62.8887339,79.5055582 64.050205,79.3055992 65.1677917,78.9398205 L65.1677917,64.8792877 L52.7924198,64.8792877 L52.7924198,74.4792713 Z",
    id: "Fill-19",
    fill: "#DDAC8C",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8907967,51.8086008 C74.8907967,38.8688139 67.7669124,31.5112975 58.9803008,31.5112975 C50.192714,31.5112975 43.069805,38.8688139 43.069805,51.8086008 C43.069805,64.7474123 50.192714,75.2379451 58.9803008,75.2379451 C67.7669124,75.2379451 74.8907967,64.7474123 74.8907967,51.8086008",
    id: "Fill-20",
    fill: "#F1C9A5",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4689686,60.7787623 C69.5852826,60.4578525 67.637795,57.1541393 68.1263736,53.4036885 C68.6091008,49.6503115 71.3396793,46.8635656 74.2253157,47.1835 C77.1080264,47.5034344 79.0525884,50.8042213 78.5659603,54.5585738 C78.0822579,58.3119508 75.3536298,61.0957705 72.4689686,60.7787623",
    id: "Fill-21",
    fill: "#E4B692",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5071802,54.5585738 C39.0195769,50.8042213 40.965114,47.5034344 43.8458744,47.1825246 C46.732486,46.8635656 49.4640397,49.6503115 49.9487174,53.4036885 C50.4353455,57.1541393 48.4868826,60.4578525 45.6031967,60.7787623 C42.7195107,61.0957705 39.9908826,58.3119508 39.5071802,54.5585738",
    id: "Fill-22",
    fill: "#F1C9A5",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8907967,51.8086008 C74.8907967,38.8688139 67.7669124,31.5112975 58.9803008,31.5112975 L58.9803008,75.2379451 C67.7669124,75.2379451 74.8907967,64.7474123 74.8907967,51.8086008",
    id: "Fill-23",
    fill: "#E4B692",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2041074,50.3473393 C76.2041074,50.3092984 76.2060579,50.2722328 76.2060579,50.2332164 C76.2060579,40.1962492 69.4127686,29.6042738 59.9035289,29.6042738 C50.3942893,29.6042738 41.7715124,40.1962492 41.7715124,50.2332164 C41.7715124,50.2722328 41.774438,50.3092984 41.774438,50.3473393 L76.2041074,50.3473393 Z",
    id: "Fill-24",
    fill: "#2E576D",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2303554,98.2577148 C88.2303554,98.2577148 88.5677769,97.8187803 85.2442727,89.3824607 C83.3065372,85.711018 75.5965537,82.7925918 69.0265868,80.903223 L58.9566033,88.8079443 L48.4819091,81.0339279 C42.015314,82.9252475 34.609595,85.7958787 32.7157438,89.3824607 C30.1021901,98.6712885 29.7296612,98.2577148 29.7296612,98.2577148 L58.9800083,98.2577148 L88.2303554,98.2577148 Z",
    id: "Fill-25",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8546628,31.4973492 C73.0370264,32.9672918 71.7165967,34.0548738 70.3639851,34.2089885 C61.9937868,35.123923 53.6362661,35.123923 45.2660678,34.2089885 C43.9154066,34.0548738 42.5930264,32.9672918 42.7773405,31.4973492 C43.3936711,27.1645787 44.0100017,22.8327836 44.6263322,18.4990377 C44.8350264,17.2036934 46.0257537,16.3228984 47.3218033,16.4565295 C54.3267124,17.214423 61.3052909,17.214423 68.3092248,16.4565295 C69.6052744,16.3228984 70.7969769,17.2036934 71.0056711,18.4990377 C71.6220017,22.8327836 72.237357,27.1645787 72.8546628,31.4973492",
    id: "Fill-26",
    fill: "#F2F2F2",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    fill: "#FF6835",
    mask: "url(#mask-4)",
    points: "63.1382893 24.4246525 59.6333967 24.4246525 59.6333967 20.9190295 55.9978264 20.9190295 55.9978264 24.4246525 52.4929339 24.4246525 52.4929339 28.0600049 55.9978264 28.0600049 55.9978264 31.5675787 59.6333967 31.5675787 59.6333967 28.0600049 63.1382893 28.0600049"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset27);
export default __webpack_public_path__ + "static/media/asset-27.14dbc57a385ebd47b75cf06b9e750216.svg";
export { ForwardRef as ReactComponent };